import type { MapaCargoSecao } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const REDATOR_SECOES_B: MapaCargoSecao[] = 
[
  {
    id: 'treinamento-e-capacitacao-da-equipe',
    titulo: 'Treinamento e capacitação da equipe',
    atividades: [
      'Identificar necessidades de desenvolvimento e promover treinamentos.',
      'Oferecer feedback contínuo para melhorar as habilidades da equipe.',
    ],
  },
  {
    id: 'gestao-de-recursos-financeiros',
    titulo: 'Gestão de recursos financeiros',
    atividades: [
      'Planejar e controlar orçamentos de projetos ou operações.',
      'Garantir o uso eficiente dos recursos disponíveis.',
    ],
  },
  {
    id: 'elaboracao-de-relatorios-e-apresentacoes',
    titulo: 'Elaboração de relatórios e apresentações',
    atividades: [
      'Preparar relatórios detalhados sobre progresso, resultados e desafios.',
      'Apresentar informações relevantes para a liderança ou stakeholders.',
    ],
  },
  {
    id: 'gestao-de-comunicacao-interna',
    titulo: 'Gestão de comunicação interna',
    atividades: [
      'Garantir que informações importantes sejam repassadas de maneira clara e objetiva.',
      'Promover a integração entre diferentes departamentos ou equipes.',
    ],
  },
  {
    id: 'garantia-de-conformidade',
    titulo: 'Garantia de conformidade',
    atividades: [
      'Assegurar que as operações estejam em conformidade com normas e regulamentos.',
      'Manter a organização alinhada com as políticas internas e exigências legais.',
    ],
  },
  {
    id: 'gestao-de-mudancas',
    titulo: 'Gestão de mudanças',
    atividades: [
      'Planejar e implementar mudanças organizacionais ou operacionais.',
      'Acompanhar o impacto das mudanças e ajustar estratégias conforme necessário.',
    ],
  },
  {
    id: 'supervisao-de-qualidade',
    titulo: 'Supervisão de qualidade',
    atividades: [
      'Garantir que operações atendam aos padrões de qualidade estabelecidos.',
      'Implementar controles de qualidade e propor melhorias contínuas.',
      'Garantir a entrega e execução proposta em cada contratação',
    ],
  },
  {
    id: 'gestao-de-projetos',
    titulo: 'Gestão de projetos',
    atividades: [
      'Planejar, executar e monitorar projetos específicos, garantindo que sejam concluídos no prazo e dentro do orçamento.',
      'Identificar riscos e desenvolver planos de contingência.',
    ],
  },
  {
    id: 'motivacao-da-equipe',
    titulo: 'Motivação da equipe',
    atividades: [
      'Criar um ambiente de trabalho positivo e motivador.',
      'Reconhecer e valorizar os esforços e conquistas da equipe.',
    ],
  },
  {
    id: 'inovacao-e-tendencias',
    titulo: 'Inovação e tendências',
    atividades: [
      'Pesquisar e implementar novas ferramentas, tecnologias ou métodos para melhorar os resultados.',
      'Ficar atento às tendências do setor e aplicá-las à organização.',
    ],
  },
  {
    id: 'atendimento-ao-cliente',
    titulo: 'Atendimento ao cliente',
    atividades: [
      'Servir de ponto de contato entre clientes e a equipe da agência.',
      'Reunir feedbacks e acompanhar o desenvolvimento das contas.',
      'Gerente Mkt',
      'Gerente',
    ],
  },
  {
    id: 'planejamento-e-estrategia',
    titulo: 'Planejamento e Estratégia',
    atividades: [
      'Desenvolver planos de longo prazo para o setor.',
      'Criar estratégias e fornecer ferramentas para melhorias do setor.',
      'Criar ações e definir o modo de operação do setor.',
      'Analisar e interpretar dados de mercado.',
      'Participar de reuniões técnicas e comerciais.',
    ],
  },
  {
    id: 'gestao-de-processos',
    titulo: 'Gestão de Processos',
    atividades: [
      'Gerir as operações diárias da organização.',
      'Implementar automação de processos.',
      'Criar ferramentas de análise de dados e acompanhamento.',
    ],
  },
  {
    id: 'lideranca-e-desenvolvimento-de-equipe',
    titulo: 'Liderança e Desenvolvimento de Equipe',
    atividades: [
      'Supervisionar o trabalho dos funcionários.',
      'Fornecer feedbacks regulares.',
      'Resolver conflitos internos.',
      'Identificar e desenvolver líderes internos.',
      'Participar do processo de contratação.',
      'Gerir desligamentos.',
    ],
  },
  {
    id: 'relacoes-externas',
    titulo: 'Relações Externas',
    atividades: [
      'Garantir bom relacionamento entre cliente e empresa.',
      'Atuar como ponto de contato com parceiros estratégicos.',
      'Promover a empresa externamente.',
    ],
  },
  {
    id: 'gestao-financeira',
    titulo: 'Gestão Financeira',
    atividades: [
      'Controlar custos operacionais.',
      'Elaborar previsões orçamentárias.',
    ],
  },
  {
    id: 'comunicacao-e-colaboracao',
    titulo: 'Comunicação e Colaboração',
    atividades: [
      'Desenvolver o relacionamento entre setores.',
      'Servir como apoio técnico para outros setores.',
      'Organizar reuniões com os funcionários.',
    ],
  },
  {
    id: 'inovacao-e-melhoria-continua',
    titulo: 'Inovação e Melhoria Contínua',
    atividades: [
      'Monitorar tendências do setor.',
      'Propor melhorias contínuas.',
    ],
  },
]
